import { Component } from './component';

export const Loading = Component as typeof Component;
